import { formatter } from '../../tools/formatter';

export const parseOrganizations = (data) => {
  return (data.privileges || []).map((org) => {
    return {
      id: org.uhcId,
      permissions: org.privileges,
      name: formatter('capitalCase', org.respOrgName),
    };
  });
};

export const parseProviders = (data) => {
  return (data.providerList || []).map((provider) => {
    const providerName = formatter('capitalCase', provider.name);

    return {
      ...provider,
      name: providerName,
      label: `${providerName} (${provider.mpin})`,
    };
  });
};

export const parseProvider = (data) => {
  let servicingProviderName;
  if (data.careProvider.firstName) {
    const firstName = formatter('name', data.careProvider.firstName);
    const lastName = formatter('name', data.careProvider.lastName);
    servicingProviderName = `${lastName}, ${firstName}`;
  } else {
    servicingProviderName = formatter(
      'name',
      data.careProvider.firstName,
      data.careProvider.lastName
    );
  }

  return {
    organizationId: data.organization.id,
    organizationName: formatter('capitalCase', data.organization.name),
    corporateProviderMpin: data.corporateTaxOwner.id,
    corporateProviderName: formatter(
      'capitalCase',
      data.corporateTaxOwner.name
    ),
    corporateProviderLastName: formatter(
      'capitalCase',
      data.corporateTaxOwner.name
    ),
    taxIdNumber: data.taxIdNumber.id,
    servicingProviderMpin: data.careProvider.id,
    servicingProviderName: formatter('capitalCase', servicingProviderName),
    servicingProviderFirstName: formatter(
      'capitalCase',
      data.careProvider.firstName
    ),
    servicingProviderLastName: formatter(
      'capitalCase',
      data.careProvider.lastName
    ),
  };
};

export const parseEmulatedProvider = (data) => {
  const { emulatedProvider } = data;
  const providerName = formatter(
    'name',
    emulatedProvider.servicingProviderFirstName,
    emulatedProvider.servicingProviderLastName
  );
  const servicingProviderName = formatter('capitalCase', providerName);
  const servicingProviderLastName = formatter(
    'capitalCase',
    emulatedProvider.servicingProviderLastName
  );
  const servicingProviderFirstName = formatter(
    'capitalCase',
    emulatedProvider.servicingProviderFirstName
  );
  const { servicingProviderMpin, taxIdNumber } = emulatedProvider;
  const providerDetails = {
    taxIdNumber,
    servicingProviderMpin,
    servicingProviderName,
    servicingProviderFirstName,
    servicingProviderLastName,
  };
  if (data.isIntakeUser) {
    return { ...providerDetails };
  }
  if (data.isInternalUser) {
    return {
      organizationId: emulatedProvider.organizationId,
      organizationName: formatter(
        'capitalCase',
        emulatedProvider.organizationName
      ),
      corporateProviderMpin: emulatedProvider.corporateProviderMpin,
      corporateProviderName: formatter(
        'capitalCase',
        emulatedProvider.corporateProviderName
      ),
      corporateProviderLastName: formatter(
        'capitalCase',
        emulatedProvider.corporateProviderLastName
      ),
      ...providerDetails,
    };
  }
  return emulatedProvider;
};
